import React from 'react';
import { useAuth } from '../context/AuthContext.tsx';
import { useNavigate, useLocation } from 'react-router-dom';

interface MobileHeaderProps {
  title?: string;
  showBackButton?: boolean;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ title, showBackButton = false }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleBack = () => {
    navigate(-1);
  };
  
  return (
    <div className="md:hidden">
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#D92D30] text-white shadow-md">
        {/* Safe-area / status-bar spacer */}
        <div className="header-safe" />

        {/* Actual header row (title always vertically centered) */}
        <div className="px-4 h-[var(--mobile-header-height)] flex justify-between items-center">
          <div className="flex items-center flex-1">
            {showBackButton && (
              <button 
                onClick={handleBack}
                className="mr-2 text-white"
                aria-label="Go back"
              >
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
            )}
            <h1 className="text-xl font-bold text-white leading-tight">
              {title || "ULTRA CLEANING"}
            </h1>
          </div>
          {user?.avatar && (
            <div className="w-8 h-8 rounded-full overflow-hidden">
              <img 
                src={user.avatar} 
                alt={`${user.name}'s avatar`} 
                className="w-full h-full object-cover"
              />
            </div>
          )}
        </div>
      </header>
      <div className="header-spacer-safe"></div>
    </div>
  );
};

export default MobileHeader; 